import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef, Inject,Optional } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { from } from "rxjs";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { LayoutUtilsService, MessageType } from "../../../../../core/_base/crud";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../../../../../environments/environment";
import * as objectPath from "object-path";
import { LayoutConfigService } from "../../../../../core/_base/layout";
import { Ba1300Class } from "../../../../../Class/ba1300/ba1300-class";
import { Tsk1020Class } from "../../../../../Class/TSK1020/tsk1020-class";
import { Tsk1020ServiceService } from "../../../../../Service/TSK1020/tsk1020-service.service";
import { Tsk5020Service } from "../../../../../Service/TSK5020/tsk5020.service";
import { Tsk5020Class } from "../../../../../Class/TSK5020/tsk5020-class";
import { DatePipe } from "@angular/common";
import { Da1300Class } from "../../../../../Class/da1300/da1300-class";
import { FileAttachmentInput } from "../../../../../Class/common/file-attachment/file-attachment-input";
import { FileAttachmentComponent } from "../../../../pages/Hrms/common/file-attachment/file-attachment.component";
import { Tsk5011Class } from "../../../../../Class/TSK5011/tsk5011-class";
import { Da9000Class } from "../../../../../Class/da9000/da9000-class";
import { CommonService } from "../../../../../Service/common/common-service.service";
import { HttpEventType } from "@angular/common/http";
import { FileAttachmentClass } from "../../../../../Class/common/file-attachment/file-attachment-class";
import { Tsk1030Class } from "../../../../../Class/TSK1030/tsk1030-class";
import { Tsk5010Service } from "../../../../../Service/TSK5010/tsk5010.service";

@Component({
	selector: "kt-tsk5020-new",
	templateUrl: "./tsk5020-new.component.html",
	styleUrls: ["./tsk5020-new.component.scss"],
	providers: [DatePipe],
})
export class Tsk5020NewComponent implements OnInit {
	@ViewChild("fileInput", { static: false }) fileInput!: ElementRef;
	private newAttribute: any = { FileId: 0, FileNameSelected: "", FileNameServer: "", Folder: "", FileIcon: "" };
	Form: FormGroup;
	closeResult: string;
	MandatoryStatus: string;
	History: any;
	isReassignDisabled:boolean=false;
	lblPageTitle: string = "";
	lblBack: string;
	lblClear: string;
	lblDelete: string;
	lblSave: string;
	lblSave_Exit: string;
	lblSave_Duplicate: string;
	lblSave_Continue: string;
	lblBack_to_Fin_Tool: string;
	lblClear_Changes_Tool: string;
	lblDelete_Selected_Entry_Tool: string;
	lblSave_Exit_Tool: string;
	lblDelMaster_Heading: string;
	lblDelMaster_Message: string;
	lblDelMaster_Progress_Message: string;
	lblDelMaster_Confirmation: string;
	lblDelMaster_Cancel: string;
	lblDelMasterDelete: string;
	lblFileAttachment:string;
	ChecklistConfig = {
		displayKey: "ChecklistName",
		search: true,
		limitTo: 50,
		placeholder: "Select",
	};
	ChecklistList: any[];
 
ChecklistSelected: Tsk1030Class;
 
 
showVerifyPopup: boolean = false;
	ChecklistData: any[];
	ChecklistId: number;	
 
	TaskId: number;
 
	isNewEntry: boolean = true;

	lblDuplication: string;
	lblMandatory: string;
	lblSystemError: string;

	lblActive: string;
	lblStrCrtdBy: string;
	lblStrCrtdOn: string;
	lblStrMdfdBy: string;
	lblStrMdfdOn: string;

	lblTaskRole: string;
	lblPriority: string;
	TaskNumber: number;
	TaskStatus: number;

	CtrlNames: any[];

	Errors: any[];
	isButtonDisabled: boolean = false;
	loaderLogo: string;
	isLoading: boolean;
	lblTaskGroupName: string;
	lblSelect: string;
	FkFieldIdTaskRole: any[];
	Prioritylist: any[];
	isstatusvisible: boolean = false;
	objFileAttachmentInput = new FileAttachmentInput();
	dialogRef: any;
	AssignedDate: string;
	TaskCaption: string;
	AssignedBy: string;
	TaskDetailsDescription: string;Attachment: string;
	TargetDate: string;
	TaskNo: string;
	showAttachmentModal: boolean = false;
	FileAttachments: any[];
	EmployeeConfig = {
		displayKey: "EmployeeName", // if objects array passed which key to be displayed defaults to description
		search: true,
		limitTo: 50,
	};

	EmployeeAssignedToSelected: Ba1300Class;
	EmployeeDisabled: Boolean;
	EmployeeList: any[];
	Taskrolelist: any[];
	TaskStatuslist: any[];
	Categorylist: any[];
	TaskCategoryList: any[];
	ProjectList: any[];
	PostList: any[];
	ReplyList: any[];
	EmployeeId: number = 0;
	lblTaskCaption: string;
	lblTaskDetailedDescription: string;
	lblAssignedTo: string;
	lblAssignedOn: string;
	lblcurrentDate: string;
	lblTargetDate: string;
	lblLinkwithTaskCategory: string;
	lblLinkwithProject: string;
	lblTaskNumber: string;
	lblTaskStatus: string;
	lblDuration: string;
	lblComments: string;
	lblCategory: string;
	lblPost: string;
	currentUrl: string;
	lblCaption: string;
	lblAssignedBy: string;
	lblDetailedDescription: string;
	lblTaskHistory: string;
	lblTaskLinkedWith: string;
	lblProjectLinkedwith: string;
	lblReply: string;
	lblReassignTask: string;
	lblAssignedtocompany: string;
	lblSlNo: string;
	lblTask: string;
	lblComment: string;
	ShowTaskStatusDiv: boolean = true;
	LinkwithChecklist: string;
	lblAttachment:string;
	icoDoc: string;
	icoImg: string;
	icoPdf: string = "UploadFiles/DocManager/Default/pdf.png";
	icoPpt: string;
	icoTxt: string;
	icoUnknown: string;
	icoXls: string;
	icoZip: string;
	photoURL: string;
	signURL: string;
	showAttachmentModalReply: boolean = false;
	private fileList: Array<any> = [];
	private fileListReply: Array<any> = [];
	objDa9000Class: Tsk5020Class = new Tsk5020Class();
	LinkwithTask: string;
	LinkwithProject: string;
	attachmentMap: { [key: number]: any[] } = {};
	attachmentMap1: { [key: number]: any[] } = {};
	attachmentMap2: { [key: number]: any[] } = {};
	fromLanding: boolean = false;
	// TaskId: number;

	showReassignPopup: boolean = false;
	showTaskTracker: boolean = false;

	RptPersonCompanyList: any[];
	TaskList: any[];

	showreassign: boolean = false;

	workedTime: string = "";
	errorMsg: string = "";

	timeInWords: string = '';
	lblApply:string;
	lblApprovedDate:string;
	lblApprovedComment:String;
	lblApproved:string;
	lblRejected:string;
	
	lblChecklist:string;
	lblVerify:string;
	lblVerifyChecklist:string;
	lblDate:string;
	lblChecklistName:string;
	lblEnterTaskorComment:string;

	attachedPostFiles: any[] = [];


	showPreviewModal: boolean = false;
	previewUrl: string = '';
	previewFileName: string = '';
	isImagePreview: boolean = false;

	constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private objTsk5020Service: Tsk5020Service, public dialog: MatDialog, private layoutUtilsService: LayoutUtilsService, private modalService: NgbModal, private changeDetectorRef: ChangeDetectorRef, private layoutConfigService: LayoutConfigService,private objTsk5010Service:Tsk5010Service,private datePipe: DatePipe, private objCommonService: CommonService,@Optional() @Inject(MAT_DIALOG_DATA) public ParamData: any, @Optional() public dialogRef1: MatDialogRef<Tsk5020NewComponent>) {}

	ngOnInit() {
		this.currentUrl = environment.baseUrl.replace("api/", "");
		this.photoURL = "UploadFiles/DocManager/Default/photo.png";
		this.signURL = "UploadFiles/DocManager/Default/sign.jpg";
		this.icoDoc = "UploadFiles/DocManager/Default/doc.png";
		this.icoImg = "UploadFiles/DocManager/Default/img.png";
		this.icoPdf = "UploadFiles/DocManager/Default/pdf.png";
		this.icoPpt = "UploadFiles/DocManager/Default/ppt.png";
		this.icoTxt = "UploadFiles/DocManager/Default/txt.png";
		this.icoUnknown = "UploadFiles/DocManager/Default/unknown.png";
		this.icoXls = "UploadFiles/DocManager/Default/xls.png";
		this.icoZip = "UploadFiles/DocManager/Default/zip.png";
		this.isLoading = true;
		this.Form = this.formBuilder.group({
			TaskId: [0],
			TaskNumber: ["", Validators.required],
			FkFieldIdTaskRole: ["", Validators.required],
			TaskCaption: ["", Validators.required],
			TaskDetailedDescription: ["", Validators.required],
			Priority: ["", Validators.required],
			FkTaskGroupId: ["", Validators.required],
			FkTaskProjectId: ["", Validators.required],
			FkEmpId: ["", Validators.required],
			AssignedonDate: ["", Validators.required],
			TargetDate: ["", Validators.required],
			TaskStatus: ["", Validators.required],
			Category: ["", Validators.required],
			Duration: ["", Validators.required],
			Comments: ["", Validators.required],
			RptPersonCompany: ["", Validators.required],
			FkChecklistId: ["", Validators.required]
		});

		const currentDateTime = new Date();
		this.Form.controls["AssignedonDate"].setValue(this.datePipe.transform(currentDateTime, "yyyy-MM-dd"));
		this.Form.controls["FkFieldIdTaskRole"].setValue("1");
		this.Form.controls["Priority"].setValue("1");
		const loaderConfig = this.layoutConfigService.getConfig("loader");
		this.loaderLogo = objectPath.get(loaderConfig, "logo");
		this.fromLanding = history.state.fromLanding || false;

		this.Errors = [];
		this.EmployeeList = [];

		this.onLoadControls();
		this.onGetCommonControlNames();
		this.onGetControlNames();
		this.changeDetectorRef.detectChanges();
	}

	ngAfterViewInit() {
		this.onClear();
		if(this.ParamData){
			if(this.ParamData.details.TaskId>0){
			this.DoFind(this.ParamData.details.TaskId, this.ParamData.details.MdfdBy, this.ParamData.details.MdfdOn);
			if(this.ParamData.flag==true){
				this.Form.disable();
				document.getElementById('btnPost').setAttribute('disabled', 'true');
				this.isReassignDisabled=true;
			}
			
		}
		}

		this.route.queryParams.subscribe((params) => {
			// var objDa9000Class = new Da9000Class();
			//       objDa9000Class.TableName='Tsk5011';
			//       objDa9000Class.AutoId = params;

			//       this.objCommonService.SelectAttachments(objDa9000Class).subscribe(data=>{
			//             this.fileList = data;
			//             this.changeDetectorRef.detectChanges();
			//          })
			// 	var objDa9000Class = new Da9000Class();
			//   objDa9000Class.TableName='Tsk5010';
			//   objDa9000Class.AutoId = params.TaskId;

			//   this.objCommonService.SelectAttachments(objDa9000Class).subscribe(data=>{
			//         this.fileList = data;
			//         this.changeDetectorRef.detectChanges();
			//      })
			if (params.type == "edit" && params.TaskId > 0) {
				document.getElementById("btnClear").style.display = "block";
				document.getElementById("btnDelete").style.display = "block";
				document.getElementById("btnSave").style.display = "block";
				document.getElementById("btnSaveMenu").style.display = "block";
				this.DoFind(params.TaskId, params.MdfdBy, params.MdfdOn);
			} else {
				document.getElementById("btnClear").style.display = "block";
				document.getElementById("btnDelete").style.display = "none";
				document.getElementById("btnSave").style.display = "block";
				document.getElementById("btnSaveMenu").style.display = "block";
			}
			if (params.MdfdBy == null && params.TaskId > 0) {
				environment.activeUrl = this.router.url;
				environment.activePageName = "tsk5020";
				environment.activeUniqueId = params.TaskId;
			}
		});
	}

	onSave(mode) {
		if (!this.objDa9000Class) {
			this.objDa9000Class = new Tsk5020Class();
			this.objDa9000Class.AttachmentList = [];
		}
		this.isLoading = true;
		this.isButtonDisabled = true;
		this.MandatoryStatus = "";
		this.onMandatoryCheck();

		if (this.MandatoryStatus != "") {
			this.layoutUtilsService.showActionNotification(this.lblMandatory + " : " + this.MandatoryStatus, MessageType.Read, 5000, true, false, 5000, "bottom");
			this.isLoading = false;
			this.changeDetectorRef.detectChanges();
			return;
		}
		//  var classobj=new ADM0009Class();
		var classobj = new Tsk5020Class();
		if (this.Form.controls["TaskId"].value != "") {
			classobj.tsk5020History = this.History;
		}

		classobj.FkFieldIdTaskRole = this.Form.controls["FkFieldIdTaskRole"].value;
		classobj.TaskCaption = this.Form.controls["TaskCaption"].value;
		classobj.TaskDetailedDescription = this.Form.controls["TaskDetailedDescription"].value;
		classobj.Priority = this.Form.controls["Priority"].value;
		classobj.FkEmpIdAssignedTo = this.EmployeeAssignedToSelected.EmpId;
		classobj.AssignedonDate = new Date(this.datePipe.transform(this.Form.controls["AssignedonDate"].value, "yyyy-MM-dd"));
		classobj.TargetDate = new Date(this.datePipe.transform(this.Form.controls["TargetDate"].value, "yyyy-MM-dd"));
		classobj.FkTaskGroupId = this.Form.controls["FkTaskGroupId"].value;
		classobj.FkTaskProjectId = this.Form.controls["FkTaskProjectId"].value;
		classobj.TaskId = this.Form.controls["TaskId"].value;
		classobj.TaskStatus = this.Form.controls["TaskStatus"].value;

		if (mode == 2) {
			classobj.TaskId = 0;
		}

		var ob = this.Form.value;
		classobj.AttachmentList = this.objDa9000Class.AttachmentList;
		this.objTsk5020Service.Create(classobj).subscribe((data) => {
			if (data.IsSuccess) {
				if (mode == 1 || mode == 2) {
					this.router.navigateByUrl("/hrms/Tsk5020-find");
					this.isLoading = false;
					this.changeDetectorRef.detectChanges();
				}
				if (mode == 3) {
					this.onClear();
					this.isButtonDisabled = false;
					this.isLoading = false;
					this.changeDetectorRef.detectChanges();
				}
			} else {
				if (data.ErrorCodes == "Duplication") {
					this.isButtonDisabled = false;
					this.isLoading = false;
					this.changeDetectorRef.detectChanges();
					this.layoutUtilsService.showActionNotification(this.lblDuplication, MessageType.Read, 2500, true, false, 2500, "bottom");
					document.getElementById("TaskId").focus();
				} else {
					this.isButtonDisabled = false;
					this.layoutUtilsService.showActionNotification(data.ErrorCodes, MessageType.Read, 5000, true, false, 5000, "bottom");
					this.isLoading = false;
					this.changeDetectorRef.detectChanges();
				}
			}
		});
	}

	onMandatoryCheck() {
		if (this.Form.controls["Category"].value == "") {
			document.getElementById("Category").focus();
			this.MandatoryStatus = this.lblCategory;
			this.isButtonDisabled = false;
			return;
		}
		if (this.Form.controls["AssignedonDate"].value == "") {
			document.getElementById("AssignedonDate").focus();
			this.MandatoryStatus = this.lblcurrentDate;
			this.isButtonDisabled = false;
			return;
		}
		if (this.Form.controls["Comments"].value == "") {
			document.getElementById("Comments").focus();
			this.MandatoryStatus = this.lblComments;
			this.isButtonDisabled = false;
			return;
		}
	}

	onGetCommonControlNames() {
		this.objTsk5020Service.GetCommonControlNames(8).subscribe((CommonControlNamesList) => {
			CommonControlNamesList.forEach((data) => {
				if (data.GeneralMsgId == 0) {
					this.lblPageTitle = data.Message;
				} else if (data.GeneralMsgId == 7) {
					this.lblBack = data.Message;
				} else if (data.GeneralMsgId == 8) {
					this.lblClear = data.Message;
					if (data.Page.AddPermission == 0) {
						document.getElementById("btnClear").style.display = "none";
					}
				} else if (data.GeneralMsgId == 9) {
					this.lblDelete = data.Message;
					if (data.Page.DeletePermission == 0) {
						document.getElementById("btnDelete").style.display = "none";
					}
				} else if (data.GeneralMsgId == 10) {
					this.lblSave = data.Message;

					this.route.queryParams.subscribe((params) => {
						if (params.type == "edit" && data.Page.EditPermission == 0) {
							document.getElementById("btnSave").style.display = "none";
							document.getElementById("btnSaveMenu").style.display = "none";
						}
					});
				} else if (data.GeneralMsgId == 11) {
					this.lblSave_Exit = data.Message;
				} else if (data.GeneralMsgId == 12) {
					this.lblSave_Duplicate = data.Message;
				} else if (data.GeneralMsgId == 13) {
					this.lblSave_Continue = data.Message;
				} else if (data.GeneralMsgId == 14) {
					this.lblBack_to_Fin_Tool = data.Message;
				} else if (data.GeneralMsgId == 15) {
					this.lblClear_Changes_Tool = data.Message;
				} else if (data.GeneralMsgId == 16) {
					this.lblDelete_Selected_Entry_Tool = data.Message;
				} else if (data.GeneralMsgId == 17) {
					this.lblSave_Exit_Tool = data.Message;
				} else if (data.GeneralMsgId == 18) {
					this.lblDelMaster_Heading = data.Message;
				} else if (data.GeneralMsgId == 19) {
					this.lblDelMaster_Message = data.Message;
				} else if (data.GeneralMsgId == 20) {
					this.lblDelMaster_Progress_Message = data.Message;
				} else if (data.GeneralMsgId == 21) {
					this.lblDelMaster_Confirmation = data.Message;
				} else if (data.GeneralMsgId == 22) {
					this.lblDelMaster_Cancel = data.Message;
				} else if (data.GeneralMsgId == 23) {
					this.lblDelMasterDelete = data.Message;
				} else if (data.GeneralMsgId == 24) {
					this.lblSelect = data.Message;
				} else if (data.GeneralMsgId == 27) {
					this.lblDuplication = data.Message;
				} else if (data.GeneralMsgId == 28) {
					this.lblMandatory = data.Message;
				} else if (data.GeneralMsgId == 29) {
					this.lblSystemError = data.Message;
				}
				 else if (data.GeneralMsgId == 50) {
					this.lblApply = data.Message;
				}
				 else if (data.GeneralMsgId == 37) {
					this.lblAttachment = data.Message;
				}
				 else if (data.GeneralMsgId == 52) {
					this.lblFileAttachment = data.Message;
				}



				
				this.isLoading = false;
			});
			this.changeDetectorRef.detectChanges();
		});
	}

	onLoadControls() {
		this.objTsk5020Service.LoadControls().subscribe((data) => {
			this.Taskrolelist = data.Taskrolelist;
			this.TaskStatuslist = data.TaskStatuslist.slice(0, 3);
			this.Categorylist = data.Categorylist;
			this.EmployeeList = data.EmployeeList;
			this.Prioritylist = data.Prioritylist;
			this.TaskCategoryList = data.TaskCategoryList;
			this.ProjectList = data.ProjectList;
			let currentUser = localStorage.getItem("currentUser");
			if (currentUser) {
				let userObj = JSON.parse(currentUser);
				let compId = userObj.CompId;
				this.Form.controls["RptPersonCompany"].setValue(compId);
						if(localStorage.getItem("PortalUser") == '1')
				{
					this.objTsk5010Service.LoadRelatedCompany(compId).subscribe((data1) => {
						this.RptPersonCompanyList=data1.RptPersonCompanyList;

					})
				}
				else{
					this.RptPersonCompanyList = data.RptPersonCompanyList;
				}

				this.changeDetectorRef.detectChanges();
			}

			this.changeDetectorRef.detectChanges();
		});
	}

	onGetControlNames() {
		this.objTsk5020Service.GetControlNames().subscribe((ControlNamesList) => {
			ControlNamesList.forEach((data) => {
				if (data.ElementID == "TaskRole") {
					this.lblTaskRole = data.ElementText;
				} else if (data.ElementID == "TaskNumber") {
					this.lblTaskNumber = data.ElementText;
				} else if (data.ElementID == "TaskCaption") {
					this.lblTaskCaption = data.ElementText;
				} else if (data.ElementID == "TaskDetailedDescription") {
					this.lblTaskDetailedDescription = data.ElementText;
				} else if (data.ElementID == "Priority") {
					this.lblPriority = data.ElementText;
				} else if (data.ElementID == "AssignedTo") {
					this.lblAssignedTo = data.ElementText;
				} else if (data.ElementID == "AssignedOn") {
					this.lblAssignedOn = data.ElementText;
				} else if (data.ElementID == "AssignedBy") {
					this.lblAssignedBy = data.ElementText;
				} else if (data.ElementID == "TaskHistory") {
					this.lblTaskHistory = data.ElementText;
				} else if (data.ElementID == "ReassignTask") {
					this.lblReassignTask = data.ElementText;
				} else if (data.ElementID == "Assignedtocompany") {
					this.lblAssignedtocompany = data.ElementText;
				} else if (data.ElementID == "CurrentDate") {
					this.lblcurrentDate = data.ElementText;
				} else if (data.ElementID == "Duration") {
					this.lblDuration = data.ElementText;
				} else if (data.ElementID == "Comments") {
					this.lblComments = data.ElementText;
				} else if (data.ElementID == "Category") {
					this.lblCategory = data.ElementText;
				} else if (data.ElementID == "Post") {
					this.lblPost = data.ElementText;
				} else if (data.ElementID == "TargetDate") {
					this.lblTargetDate = data.ElementText;
				} else if (data.ElementID == "LinkwithTaskCategory") {
					this.lblLinkwithTaskCategory = data.ElementText;
				} else if (data.ElementID == "LinkwithProject") {
					this.lblLinkwithProject = data.ElementText;
				} else if (data.ElementID == "Caption") {
					this.lblCaption = data.ElementText;
				} else if (data.ElementID == "DetailedDescription") {
					this.lblDetailedDescription = data.ElementText;
				} else if (data.ElementID == "TaskLinkedWith") {
					this.lblTaskLinkedWith = data.ElementText;
				} else if (data.ElementID == "ProjectLinkedwith") {
					this.lblProjectLinkedwith = data.ElementText;
				} else if (data.ElementID == "Reply") {
					this.lblReply = data.ElementText;
				} else if (data.ElementID == "Task") {
					this.lblTask = data.ElementText;
				} else if (data.ElementID == "Comment") {
					this.lblComment = data.ElementText;
				} else if (data.ElementID == "TaskStatus") {
					this.lblTaskStatus = data.ElementText;
				} else if (data.ElementID == "SlNo") {
					this.lblSlNo = data.ElementText;
				}
				else if (data.ElementID == "Checklist") {
					this.lblChecklist = data.ElementText;
				}
				else if (data.ElementID == "Verify") {
					this.lblVerify = data.ElementText;
				}
				else if (data.ElementID == "VerifyChecklist") {
					this.lblVerifyChecklist = data.ElementText;
				}
				else if (data.ElementID == "Date") {
					this.lblDate = data.ElementText;
				}
					else if (data.ElementID == "ChecklistName") {
					this.lblChecklistName = data.ElementText;
				}
				else if (data.ElementID == "EnterTaskorComment") {
					this.lblEnterTaskorComment = data.ElementText;
				}
				else if (data.ElementID == "ApprovedDate") {
					this.lblApprovedDate = data.ElementText;
				}
				else if (data.ElementID == "ApprovedComment") {
					this.lblApprovedComment = data.ElementText;
				}
				else if (data.ElementID == "Approved") {
					this.lblApproved = data.ElementText;
				}
				else if (data.ElementID == "Rejected") {
					this.lblRejected = data.ElementText;
				}
				if (this.route.snapshot.queryParams["type"] != "edit") {
					this.isLoading = false;
				}
			});
			this.changeDetectorRef.detectChanges();
		});
	}
	onBack() {
		this.route.queryParams.subscribe((params) => {
			if (params.Pagename == "landing") {
				this.router.navigate(["/widget"]);
			} else if (params.Pagename == "ChartReport") {
				this.router.navigateByUrl("/hrms/Tsk5010-report");
			} else {
				this.router.navigateByUrl("/hrms/Tsk5020-find");
			}
		});
	}

	onClear() {
		environment.activeUrl = "";
		environment.activePageName = "";
		environment.activeUniqueId = "";
		this.Form.controls["TaskId"].setValue(0);
		this.Form.controls["FkFieldIdTaskRole"].setValue("1");
		this.Form.controls["TaskCaption"].setValue("");
		this.Form.controls["TaskDetailedDescription"].setValue("");
		this.Form.controls["Priority"].setValue("1");
		this.EmployeeAssignedToSelected = new Ba1300Class();
		this.Form.controls["TargetDate"].setValue("");
		this.Form.controls["FkTaskGroupId"].setValue("");
		this.Form.controls["FkTaskProjectId"].setValue("");

		var varStrMdfdBy = <HTMLFormElement>document.getElementById("StrMdfdBy");

		this.lblStrCrtdBy = "";
		this.lblStrCrtdOn = "";
		this.lblStrMdfdBy = "";
		this.lblStrMdfdOn = "";
		this.PostList = [];
		this.ReplyList = [];
		if(!this.ParamData){
			document.getElementById("btnSave").style.display = "block";
			document.getElementById("btnSaveMenu").style.display = "block";
			document.getElementById("btnDelete").style.display = "none";
		}
		this.isLoading = false;
		this.changeDetectorRef.detectChanges();
	}

	onDelete() {
		const _title = this.lblDelMaster_Heading;
		const _description = this.lblDelMaster_Message;
		const _waitDesciption = this.lblDelMaster_Progress_Message;
		const _deleteMessage = this.lblDelMaster_Confirmation;

		var TaskId = this.Form.controls["TaskId"].value;
		const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
		dialogRef.afterClosed().subscribe((res) => {
			if (!res) {
				return;
			}
			this.objTsk5020Service.Delete(TaskId).subscribe((data) => {
				if (data) {
					this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete, 5000, true, false, 5000, "bottom");
					this.router.navigate(["/hrms/Tsk5020-find"]);
				}
			});
		});
	}

	DoFind(TaskId, MdfdBy, MdfdOn) {
		this.isLoading = true;
		var classobj = new Tsk5020Class();
		classobj.TaskId = TaskId;
		classobj.MdfdBy = MdfdBy;
		classobj.MdfdOn = MdfdOn;
		this.isstatusvisible = true;
		this.objTsk5020Service.DoFind(classobj).subscribe((data) => {
			var tempHistory = JSON.stringify(data);
			this.History = JSON.parse(tempHistory);
			// this.Form.controls["FkCompId"].setValue(data.FkCompId);
			this.Form.controls["TaskNumber"].setValue(data.TaskNumber);
			this.TaskStatus = data.TaskStatus;
			this.Form.controls["TaskId"].setValue(data.TaskId);
			this.TaskId = this.Form.controls["TaskId"].value;
			this.Form.controls["FkFieldIdTaskRole"].setValue(data.FkFieldIdTaskRole);
			if (data.FkFieldIdTaskRole == "1") {
				this.showreassign = true;
			}
			this.ChecklistSelected = new Tsk1030Class();
			this.ChecklistSelected.ChecklistId = data.FkChecklistId;
			this.ChecklistSelected.ChecklistName = data.ChecklistName;
			this.LinkwithChecklist=data.LinkwithChecklist;
			this.Form.controls["TaskCaption"].setValue(data.TaskCaption);
			this.Form.controls["TaskDetailedDescription"].setValue(data.TaskDetailedDescription);
			this.TaskDetailsDescription = data.TaskDetailedDescription;
			this.Form.controls["Priority"].setValue(data.Priority);
			// this.Form.controls["AssignedonDate"].setValue(data.AssignedonDate);
			this.Form.controls["TargetDate"].setValue(data.TargetDate);
			this.Form.controls["FkTaskGroupId"].setValue(data.FkTaskGroupId);
			this.Form.controls["FkTaskProjectId"].setValue(data.FkTaskProjectId);
			this.Form.controls["TaskId"].setValue(data.TaskId);
			this.Form.controls["TaskStatus"].setValue(data.TaskStatus);
			if (data.FkFieldIdTaskRole == 1) {
				this.Categorylist = this.Categorylist; // Load dropdown options
				this.Form.controls["Category"].setValue(1);
			} else if (data.FkFieldIdTaskRole == 2) {
				this.Categorylist = this.Categorylist; // Load dropdown options
				this.Form.controls["Category"].setValue(1);
			} else {
				this.Categorylist = this.Categorylist; // Still load options
				this.Form.controls["Category"].setValue("");
			}

			if (data.TaskStatus == 2) {
				this.Form.controls["TaskStatus"].enable();
			} else if (data.TaskStatus == 9) {
				this.ShowTaskStatusDiv = false;
			} else {
				this.Form.controls["TaskStatus"].enable();
			}

			this.ReplyList = data.ReplyDataList;
			this.ReplyList.forEach((reply) => {
				const objDa9000Class = new Da9000Class();
				objDa9000Class.TableName = "Tsk5011";
				objDa9000Class.AutoId = reply.TaskDetailsId;

				this.objCommonService.SelectAttachments(objDa9000Class).subscribe((fileData) => {
					this.attachmentMap1[reply.TaskDetailsId] = fileData;
					this.changeDetectorRef.detectChanges();
				});
			});

			const objDa9000Class = new Da9000Class();
			objDa9000Class.TableName = "Tsk5010";
			objDa9000Class.AutoId = this.Form.controls["TaskId"].value;

			this.objCommonService.SelectAttachments(objDa9000Class).subscribe((fileData) => {
				this.FileAttachments = fileData;
				this.changeDetectorRef.detectChanges();
			});

			this.TaskNo = data.TaskNumber;
			this.AssignedDate = data.StrAssignedonDate;
			this.AssignedBy = data.EmployeeNameAssignedBy;
			this.LinkwithTask = data.LinkwithTask;
			this.LinkwithProject = data.LinkwithProject;
			this.TaskCaption = data.TaskCaption;
			this.TaskDetailsDescription = data.TaskDetailedDescription;
			// this.Attachment=data.TaskCaption;
			this.TargetDate = data.StrTargetDate;

			// this.Form.controls["FkEmpIdAssignedTo"].setValue(data.FkEmpIdAssignedTo);
			// this.EmployeeSelected=new Ba1300Class;
			this.EmployeeAssignedToSelected = new Ba1300Class();
			this.EmployeeAssignedToSelected.EmpId = data.FkEmpIdAssignedTo;
			this.LoadProject(data.FkEmpIdAssignedTo);
			this.EmployeeAssignedToSelected.EmployeeName = data.EmployeeNameAssignedTo;
			this.EmployeeAssignedToSelected.EmpNo = data.EmployeeNumberAssignedTo;
			this.EmployeeId = data.FkEmpIdAssignedTo;
			this.PostList = data.PostDataList;
			this.PostList.forEach((Post) => {
				const objDa9000Class = new Da9000Class();
				objDa9000Class.TableName = "Tsk5011";
				objDa9000Class.AutoId = Post.TaskDetailsId;

				this.objCommonService.SelectAttachments(objDa9000Class).subscribe((fileData) => {
					this.attachmentMap[Post.TaskDetailsId] = fileData;
					this.changeDetectorRef.detectChanges();
				});
			});

			this.changeDetectorRef.detectChanges();

			this.lblStrCrtdBy = "Created By: " + data.StrCrtdBy + " on " + data.StrCrtdOn;
			this.lblStrMdfdBy = "Modified By: " + data.StrMdfdBy + " on " + data.StrMdfdOn;
			this.isLoading = false;
		});
	}

	getComponentTitle() {
		let result = this.lblPageTitle;
		// let result = "My Task";
		return result;
	}

	onGetUserEmployees() {}

	EmployeeProjectList(event: any) {
		const empid = event.value.EmpId;
		var classobj = new Tsk5020Class();
		classobj.FkEmpId = empid;
		this.objTsk5020Service.LoadEmployeeProjectList(classobj).subscribe((data) => {
			this.ProjectList = data.ProjectList;
		});
	}

	onAttachment(OtherDocId, PageName, TableName) {

		this.objFileAttachmentInput = new FileAttachmentInput();
		this.objFileAttachmentInput.FkPageId = 0;
		this.objFileAttachmentInput.PageName = PageName;
		this.objFileAttachmentInput.TableName = TableName;
		this.objFileAttachmentInput.AutoId = this.Form.controls["TaskId"].value;
		this.objFileAttachmentInput.Flag = "hidden";
		this.dialogRef = this.dialog.open(FileAttachmentComponent, {
			width: "800px",
			height: "600px",
			data: this.objFileAttachmentInput,
		});

		this.dialogRef.afterClosed().subscribe((result) => {
			if (result != "") {
				alert(result);
			}

			this.changeDetectorRef.detectChanges();
		});
	}
	onAttachment1(OtherDocId, PageName, TableName) {

		this.objFileAttachmentInput = new FileAttachmentInput();
		this.objFileAttachmentInput.FkPageId = 0;
		this.objFileAttachmentInput.PageName = PageName;
		this.objFileAttachmentInput.TableName = TableName;
		this.objFileAttachmentInput.AutoId = OtherDocId;
		this.objFileAttachmentInput.Flag = "hidden";
		this.dialogRef = this.dialog.open(FileAttachmentComponent, {
			width: "800px",
			height: "600px",
			data: this.objFileAttachmentInput,
		});

		this.dialogRef.afterClosed().subscribe((result) => {
			if (result != "") {
				alert(result);
			}

			this.changeDetectorRef.detectChanges();
		});
	}

	LoadProject(EmpId: number) {
		var classobj = new Tsk5020Class();
		classobj.FkEmpId = EmpId;
		this.objTsk5020Service.LoadEmployeeProjectList(classobj).subscribe((data) => {
			this.ProjectList = data.ProjectList;
		});
	}

	onPost() {
		this.isLoading=true;
		if (this.errorMsg && this.errorMsg.trim() !== "") {
			this.isLoading=false;
			this.layoutUtilsService.showActionNotification("Please correct the Duration field before posting.", MessageType.Read, 5000, true, false, 5000, "bottom");
			return;
		}

		if (!this.objDa9000Class) {
			this.objDa9000Class = new Tsk5020Class();
			this.attachedPostFiles = [];
		}
		this.MandatoryStatus = "";
		``;
		this.onMandatoryCheckPost();

		if (this.MandatoryStatus != "") {
			this.layoutUtilsService.showActionNotification(this.lblMandatory + " : " + this.MandatoryStatus, MessageType.Read, 5000, true, false, 5000, "bottom");
			this.isLoading = false;
			this.changeDetectorRef.detectChanges();
			return;
		}

		var classobj = new Tsk5020Class();

		classobj.TaskId = this.Form.controls["TaskId"].value;
		classobj.CategoryId = this.Form.controls["Category"].value;
		classobj.CurrentDate = new Date(this.datePipe.transform(this.Form.controls["AssignedonDate"].value, "yyyy-MM-dd"));

		// classobj.CurrentDate = this.Form.controls["AssignedonDate"].value;
		classobj.Duration = this.Form.controls["Duration"].value;
		classobj.Comments = this.Form.controls["Comments"].value;
		classobj.TaskStatus = this.Form.controls["TaskStatus"].value;
		classobj.AttachmentList = this.objDa9000Class.AttachmentList;

		if (this.Form.controls["TaskStatus"].value == 2) {
			this.Form.controls["TaskStatus"].disable();
		} else {
			this.Form.controls["TaskStatus"].enable();
		}

		this.objTsk5020Service.Post(classobj).subscribe((data) => {
			if (data) {

				const role = this.Form.controls["FkFieldIdTaskRole"].value;

				if (role == 2) {
					this.Form.controls["Category"].setValue(1); // Self Task → Task
				} else {
					this.Form.controls["Category"].setValue(1); // Assign Task → Task
				}

				this.attachedPostFiles = [];
				this.objTsk5020Service.GetPostedData(classobj).subscribe((data) => {
					this.PostList = data.PostDataList;
					this.fileList = [];

					this.PostList.forEach((reply) => {
						const objDa9000Class = new Da9000Class();
						objDa9000Class.TableName = "Tsk5011";
						objDa9000Class.AutoId = reply.TaskDetailsId;

						this.objCommonService.SelectAttachments(objDa9000Class).subscribe((fileData) => {
							this.attachmentMap[reply.TaskDetailsId] = fileData;
							this.isLoading=false;
							this.changeDetectorRef.detectChanges();
						});
					});
					this.changeDetectorRef.detectChanges();
					this.Form.patchValue({
						Duration: "",
						Comments: "",
					});

					this.layoutUtilsService.showActionNotification("Posted Successfully", MessageType.Create, 5000, true, false, 5000, "bottom");
				});
				setTimeout(() => {
					if(this.ParamData){
						if(this.ParamData.details.TaskId>0){
							this.dialogRef1.close();
							this.router.navigate(["/widget"]);
						}
					}
					else{
						this.router.navigateByUrl("/hrms/Tsk5020-find");
					}
				}, 1000); //
			}
		});
	}
	triggerFileUpload(): void {
		this.fileInput.nativeElement.click(); // Triggers the file selection dialog
	}
	onFileSelected(event: any): void {
		//   this.fileList = [];
		//   this.objDa9000Class.AttachmentList = [];

		const files: FileList = event.target.files;
		if (!files || files.length === 0) return;

		Array.from(files).forEach((file: File) => {
			// const fileType = file.name.split(".").pop()?.toLowerCase() || "";
			const formData = new FormData();
			formData.append("file", file, file.name);

			this.objCommonService.TempFileCreate(formData).subscribe((event) => {
				this.icoPdf = "UploadFiles/DocManager/Default/pdf.png";

				if (event.type === HttpEventType.UploadProgress) {
					const progress = Math.round((100 * event.loaded) / event.total);
				} else if (event.type === HttpEventType.Response) {
					const savedfilename = event.body.dbPath;
					const geturl = "UploadFiles/DocManager/temp/" + savedfilename;

					const newAttribute: any = {};
					newAttribute.FileId = 0;
					newAttribute.PageName = "Tsk5010";
					newAttribute.FileNameSelected = file.name;
					newAttribute.FileNameServer = savedfilename;
					newAttribute.Folder = "UploadFiles/DocManager/temp/";

					// Assign icon
					if (/\.(doc|docx)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoDoc;
					} else if (/\.(xls|xlsx)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoXls;
					} else if (/\.(txt|csv)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoTxt;
					} else if (/\.pdf$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoPdf;
					} else if (/\.(ppt|pptx)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoPpt;
					} else if (/\.(zip|rar)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoZip;
					} else if (/\.(jpg|jpeg|png|gif|tif)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoImg;
					} else {
						newAttribute.FileIcon = this.icoUnknown;
					}

					this.fileList.push(newAttribute);

					if (!this.objDa9000Class) {
						this.objDa9000Class = new Tsk5020Class();
						this.objDa9000Class.TableName = "Tsk5011";
						this.objDa9000Class.AutoId = 0;
						this.objDa9000Class.AttachmentList = [];
					}

					if (!this.objDa9000Class.AttachmentList) {
						this.objDa9000Class.AttachmentList = [];
					}

					const strTempUrl = environment.baseUrl.replace("api/", "");

					const objFileAttachmentClass = new FileAttachmentClass();
					objFileAttachmentClass.FileId = newAttribute.FileId;
					objFileAttachmentClass.FileNameSelected = newAttribute.FileNameSelected;
					objFileAttachmentClass.FileNameServer = newAttribute.FileNameServer;
					objFileAttachmentClass.Folder = newAttribute.Folder.replace(strTempUrl, "");
					objFileAttachmentClass.FkPageId = 0;
					objFileAttachmentClass.PageName = "Tsk5010";
					objFileAttachmentClass.TableName = "Tsk5011";
					objFileAttachmentClass.AutoId = 0;

					this.objDa9000Class.AttachmentList.push(objFileAttachmentClass);

					this.changeDetectorRef.detectChanges();
				}
			});

			console.log("Selected file:", file.name);
		});
	}
	onFileSelected2(event: any): void {
		//   this.fileList = [];
		//   this.objDa9000Class.AttachmentList = [];

		const files: FileList = event.target.files;
		if (!files || files.length === 0) return;

		Array.from(files).forEach((file: File) => {
			// const fileType = file.name.split(".").pop()?.toLowerCase() || "";
			const formData = new FormData();
			formData.append("file", file, file.name);

			this.objCommonService.TempFileCreate(formData).subscribe((event) => {
				this.icoPdf = "UploadFiles/DocManager/Default/pdf.png";

				if (event.type === HttpEventType.UploadProgress) {
					const progress = Math.round((100 * event.loaded) / event.total);
				} else if (event.type === HttpEventType.Response) {
					const savedfilename = event.body.dbPath;
					const geturl = "UploadFiles/DocManager/temp/" + savedfilename;

					const newAttribute: any = {};
					newAttribute.FileId = 0;
					newAttribute.PageName = "Tsk5010";
					newAttribute.FileNameSelected = file.name;
					newAttribute.FileNameServer = savedfilename;
					newAttribute.Folder = "UploadFiles/DocManager/temp/";

					// Assign icon
					if (/\.(doc|docx)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoDoc;
					} else if (/\.(xls|xlsx)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoXls;
					} else if (/\.(txt|csv)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoTxt;
					} else if (/\.pdf$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoPdf;
					} else if (/\.(ppt|pptx)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoPpt;
					} else if (/\.(zip|rar)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoZip;
					} else if (/\.(jpg|jpeg|png|gif|tif)$/i.test(savedfilename)) {
						newAttribute.FileIcon = this.icoImg;
					} else {
						newAttribute.FileIcon = this.icoUnknown;
					}

					this.fileListReply.push(newAttribute);

					if (!this.objDa9000Class) {
						this.objDa9000Class = new Tsk5020Class();
						this.objDa9000Class.TableName = "Tsk5011";
						this.objDa9000Class.AutoId = 0;
						this.objDa9000Class.AttachmentList = [];
					}

					if (!this.objDa9000Class.AttachmentList) {
						this.objDa9000Class.AttachmentList = [];
					}

					const strTempUrl = environment.baseUrl.replace("api/", "");

					const objFileAttachmentClass = new FileAttachmentClass();
					objFileAttachmentClass.FileId = newAttribute.FileId;
					objFileAttachmentClass.FileNameSelected = newAttribute.FileNameSelected;
					objFileAttachmentClass.FileNameServer = newAttribute.FileNameServer;
					objFileAttachmentClass.Folder = newAttribute.Folder.replace(strTempUrl, "");
					objFileAttachmentClass.FkPageId = 0;
					objFileAttachmentClass.PageName = "Tsk5010";
					objFileAttachmentClass.TableName = "Tsk5011";
					objFileAttachmentClass.AutoId = 0;

					this.objDa9000Class.AttachmentList.push(objFileAttachmentClass);

					this.changeDetectorRef.detectChanges();
				}
			});

			console.log("Selected file:", file.name);
		});
	}

	OpenFile(file) {
		window.open(file);
	}
	removeAttachmentreply(index) {
		// this.fileListReply.splice(index, 1);
			this.fileListReply[index].isHidden = true;

	}

	openModalReply() {
		this.showAttachmentModalReply = true;
	}

	closeModalReply() {
		this.showAttachmentModalReply = false;
	}
	removeAttachment(index) {
		// this.fileList.splice(index, 1);
		  this.fileList[index].isHidden = true;

	}
	openModal() {
		this.showAttachmentModal = true;
	}

	closeModal() {
		this.showAttachmentModal = false;
	}

	//backComment
	Close() {
		// this.fileList = this.fileList.filter(file => file.Flag === 1);
		//  this.objDa9000Class.AttachmentList= this.objDa9000Class.AttachmentList.filter(file => file.Flag === 1);
		// this.showAttachmentModal = false;

		this.showAttachmentModal = false;
	this.fileList = this.fileList.filter(file => file.Flag === 1);
	this.objDa9000Class.AttachmentList= this.objDa9000Class.AttachmentList.filter(file => file.Flag === 1);
	this.fileList.forEach(item => item.isHidden = false);


	}
	onClearAttach() {
		// this.fileList = [];
		// this.objDa9000Class.AttachmentList = [];

			this.fileList.forEach(item => item.isHidden = true);
	this.objDa9000Class.AttachmentList.forEach(item => item.isHidden = true);
	}

AttachComments(){

	   
//   this.fileList.forEach(file => {
//     file.Flag = 1;
//   });
//   this.objDa9000Class.AttachmentList.forEach(file => {
//     file.Flag = 1;
//   });
//   this.showAttachmentModal = false;  


	this.fileList = this.fileList; // assign selected files
	this.fileList.forEach(file => {
		if (!file.isHidden) {   // only update visible rows
		file.Flag = 1;
		}
	});
		this.objDa9000Class.AttachmentList.forEach(file => {
		file.Flag = 1;
		});
	this.showAttachmentModal = false;  // close modal
	this.fileList = this.fileList.filter(file => file.Flag == 1 && !file.isHidden);
	this.objDa9000Class.AttachmentList=this.objDa9000Class.AttachmentList.filter(file => file.Flag == 1 && !file.isHidden);


}


	onMandatoryCheckPost() {
		if (this.Form.controls["Category"].value == "") {
			document.getElementById("Category").focus();
			this.MandatoryStatus = this.lblCategory;
			this.isButtonDisabled = false;
			return;
		}

		if (this.Form.controls["Category"].value == "1" && this.Form.controls["Duration"].value == "") {
			document.getElementById("Duration").focus();
			this.MandatoryStatus = this.lblDuration;
			this.isButtonDisabled = false;
			return;
		}

		if (this.Form.controls["Comments"].value == "") {
			// document.getElementById("Reply").focus();
			this.MandatoryStatus = this.lblComments;
			this.isButtonDisabled = false;
			return;
		}
	}
	onDateSelected(event: any) {
		const selectedDate: Date = event.value;
		const currentDateTime = new Date();
		if (selectedDate < new Date(this.AssignedDate)) {
			this.layoutUtilsService.showActionNotification("Selected date cannot be before assigned date.", MessageType.Read, 5000, true, false, 5000, "bottom");
			this.Form.controls["AssignedonDate"].setValue(this.datePipe.transform(currentDateTime, "yyyy-MM-dd")); // reset
		}
	}

	ChangeCompany(ComapnyId) {
		this.EmployeeAssignedToSelected = new Ba1300Class();
		this.objTsk5020Service.ChangeCompany(ComapnyId).subscribe((list) => {
			this.EmployeeList = list;
			this.changeDetectorRef.detectChanges();
		});
	}

	onReassignSave() {
		this.MandatoryStatus = "";
		``;
		this.onMandatoryPopUp();

		if (this.MandatoryStatus != "") {
			this.layoutUtilsService.showActionNotification(this.lblMandatory + " : " + this.MandatoryStatus, MessageType.Read, 5000, true, false, 5000, "bottom");
			this.isLoading = false;
			this.changeDetectorRef.detectChanges();
			return;
		}

		var classobj = new Tsk5020Class();

		classobj.FkEmpIdAssignedTo = this.EmployeeAssignedToSelected.EmpId;
		classobj.AssignedonDate = new Date(this.datePipe.transform(this.Form.controls["AssignedonDate"].value, "yyyy-MM-dd"));
		classobj.TargetDate = new Date(this.datePipe.transform(this.Form.controls["TargetDate"].value, "yyyy-MM-dd"));
		classobj.TaskId = this.Form.controls["TaskId"].value;
		classobj.FkCompIdAssignedTo = this.Form.controls["RptPersonCompany"].value;

		this.objTsk5020Service.PopUPCreate(classobj).subscribe((data) => {
			this.layoutUtilsService.showActionNotification("Task Re-Assigned Successfully", MessageType.Create, 5000, true, false, 5000, "bottom");
			this.changeDetectorRef.detectChanges();
			 this.dialogRef1.close('REASSIGNED');
		});
		setTimeout(() => {
			if(this.ParamData){
				if(this.ParamData.details.TaskId>0){
					// this.dialogRef1.close();
					this.router.navigate(["/widget"]);
				}
			}
			else{
				this.router.navigateByUrl("/hrms/Tsk5020-find");
				
			}
		}, 1000); //
		this.showReassignPopup = false; // close popup after confirm
	}

	onClearPopUp() {
		this.EmployeeAssignedToSelected = new Ba1300Class();
		this.Form.controls["TargetDate"].setValue("");

		this.changeDetectorRef.detectChanges();
	}

	onMandatoryPopUp() {
		if (!this.EmployeeAssignedToSelected || !this.EmployeeAssignedToSelected.EmpId || this.EmployeeAssignedToSelected.EmpId === 0) {
			this.MandatoryStatus = this.lblAssignedTo;
			this.isButtonDisabled = false;
			return;
		}

		// if(this.Form.controls["TargetDate"].value =='' || this.Form.controls["TargetDate"].value ==null)
		// 	{
		// 	this.MandatoryStatus=this.lblTargetDate;
		// 	this.isButtonDisabled=false;
		// 	return;
		// 	}
	}

	TaskHistory() {

		var classobj = new Tsk5020Class();
		classobj.TaskId = this.Form.controls["TaskId"].value;

		this.objTsk5020Service.TaskHistory(classobj).subscribe((data) => {

			this.showTaskTracker = true;
			this.TaskList = data.TaskList;
			this.changeDetectorRef.detectChanges();
		});
	}

	openReassignPopup() {
		this.showReassignPopup = true;

		// Reset controls
		this.Form.patchValue({
			TargetDate: null,
		});

		this.EmployeeAssignedToSelected = null; // for ngx-select-dropdown
	}

// parseHoursMinutes(value: string): { hours: number; minutes: number } | null {

//   const match = value.trim().match(/^([0-9]{1,5}):([0-9]{1,2})$/);
//   if (!match) return null; 
 
//   const hours = parseInt(match[1], 10);
//   const minutes = parseInt(match[2], 10);
 
//   if (isNaN(hours) || isNaN(minutes) || minutes >= 60) return null;
//   return { hours, minutes };
// }


 
// updateDisplay(): void {
//   const parsed = this.parseHoursMinutes(this.workedTime);
 
//   if (!parsed) {
//     this.errorMsg = 'Invalid format. Use HH:MM (minutes < 60)';
//     this.timeInWords = '';
//     return;
//   }
 
//   const { hours, minutes } = parsed;
 
//   if (hours === 0 && minutes === 0) {
//     this.errorMsg = 'Duration cannot be 00:00';
//     this.timeInWords = '';
//     return;
//   }
 
//   this.errorMsg = '';
 

//   const hourText = hours === 1 ? '1 hour' : `${hours} hours`;
//   const minuteText =
//     minutes === 0 ? '' : minutes === 1 ? '1 minute' : `${minutes} minutes`;
 
//   this.timeInWords = minuteText ? `${hourText} and ${minuteText}` : hourText;
// }
 



parseHoursMinutes(value: string): { hours: number; minutes: number } | null {
  const match = value.trim().match(/^([0-9]{1,5}):([0-9]{1,2})$/);
  if (!match) return null;

  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);

  if (isNaN(hours) || isNaN(minutes) || minutes >= 60) return null;
  return { hours, minutes };
}

updateDisplay(): void {
  const parsed = this.parseHoursMinutes(this.workedTime);

  if (!parsed) {
    this.errorMsg = 'Invalid format. Use HH:MM (minutes < 60)';
    this.timeInWords = '';
    return;
  }

  const hours = parsed.hours;
  const minutes = parsed.minutes;
  this.errorMsg = '';

  if (hours > 12 || (hours === 12 && minutes > 0)) {

    const title = 'Time Warning';
    const description = 'You have entered more than 12 hours. Are you sure you want to continue?';
    const waitDescription = 'Processing';
    const btnNo = 'No';
    const btnYes = 'Yes';

    const dialogRef = this.layoutUtilsService.Commondialog(
      title,
      description,
      waitDescription,
      btnNo,
      btnYes
    );

    dialogRef.afterClosed().subscribe((res) => {

      if (!res) {

        this.workedTime = '';
        this.Form.get('Duration').setValue('');
        this.timeInWords = '';
        return;
      }

      this.setTimeWords(hours, minutes);
    });

    return; 
  }


  this.setTimeWords(hours, minutes);
}


setTimeWords(hours: number, minutes: number): void {
  const hourText = hours === 1 ? '1 hour' : hours + ' hours';
  const minuteText =
  minutes === 0 ? '' : minutes === 1 ? '1 minute' : minutes + ' minutes';
  this.timeInWords = minuteText ? hourText + ' and ' + minuteText : hourText;
}





onVerifyChecklist() {

	this.TaskId = this.Form.controls["TaskId"].value;
	this.ChecklistId = this.ChecklistSelected.ChecklistId;
if(this.ChecklistId && this.TaskId){

	this.objTsk5020Service.Verify(this.ChecklistId,this.TaskId).subscribe((data) => {

		this.ChecklistData=data.ChecklistDatalist;

	this.showVerifyPopup = true;
	this.changeDetectorRef.detectChanges();
		});
}

this.showVerifyPopup = true;
this.changeDetectorRef.detectChanges();
}


onClearVerifyPopup() {
if (this.ChecklistData && this.ChecklistData.length > 0) {
this.ChecklistData.forEach(item => {
	item.ChecklistDate = null;
	item.ChecklistComment = '';
	
});
}

const checkboxes = document.querySelectorAll('input[type="checkbox"]');
checkboxes.forEach((checkbox: any) => (checkbox.checked = false));
}

onChecklistVerifyChange(event: Event, index: number) {
  const checkbox = event.target as HTMLInputElement;
  const isChecked = checkbox.checked;
 
  if (!this.ChecklistData || !this.ChecklistData[index]) {
    return;
  }
 
  if (isChecked) {
    // set a Date object — mat-datepicker works with Date
    this.ChecklistData[index].ChecklistDate = new Date();
    this.ChecklistData[index].IsVerified = true;
  } else {
    this.ChecklistData[index].ChecklistDate = null;
    this.ChecklistData[index].IsVerified = false;
  }
}


onVerifySave() {




  var classobj = new Tsk5020Class();
  classobj.Tsk5020List = [];


  classobj.TaskId = this.TaskId; 
  

  for (var i = 0; i < this.ChecklistData.length; i++) {
    var item = this.ChecklistData[i];

    // Save only rows that are checked 
    if (item.IsVerified) {
      var checklistItem = new Tsk5020Class();
      checklistItem.ChecklistDtlsId = item.ChecklistDtlsId;
      checklistItem.ChecklistName = item.ChecklistName;
      checklistItem.ChecklistDate = item.ChecklistDate;
      checklistItem.ChecklistComment = item.ChecklistComment;
    //   checklistItem.IsVerified = item.IsVerified;

      classobj.Tsk5020List.push(checklistItem);
    }
  }

  //  No checked rows → show warning
  if (classobj.Tsk5020List.length === 0) {
    this.layoutUtilsService.showActionNotification(
      "Please verify at least one checklist before saving.",
      MessageType.Read,
      4000,
      true,
      false,
      4000,
      "bottom"
    );
    return;
  }

  //  Call the API using your service
//    this.isLoading = true;
  this.objTsk5020Service.SaveChecklist(classobj).subscribe({
    next: (data) => {
      this.isLoading = false;

      if (data && data.ErrorCodes && data.ErrorCodes.length > 0) {
        this.layoutUtilsService.showActionNotification(
          data.ErrorCodes.join(", "),
          MessageType.Read,
          5000,
          true,
          false,
          5000,
          "bottom"
        );
      } else {
		
        this.layoutUtilsService.showActionNotification(
          "Checklist saved successfully!",
          MessageType.Create,
          3000,
          true,
          false,
          3000,
          "bottom"
        );
		 this.isLoading = false;
		this.showVerifyPopup = false;
		this.changeDetectorRef.detectChanges();

        // Hide popup and refresh data / go back
       
        // this.loadChecklistData(); // if you have reload method
      }
    },
    error: (err) => {
      this.isLoading = false;
      this.layoutUtilsService.showActionNotification(
        "Error while saving checklist: " + err.message,
        MessageType.Read,
        5000,
        true,
        false,
        5000,
        "bottom"
      );
    },
  });
}
onClose(){
 this.dialogRef1.close();
}

getTaskStatusName(id: any) {
  const item = this.TaskStatuslist.find(x => x.FieldId == id);
  return item ? item.FieldValue : '';
}



onPostFileSelected(event: any): void {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file: File) => {
        const fileObj = { file: file, progress: 0, serverFile: null };
        this.attachedPostFiles.push(fileObj);

        const formData = new FormData();
        formData.append('file', file, file.name);

        this.objCommonService.TempFileCreate(formData).subscribe((evt) => {
            if (evt.type === HttpEventType.UploadProgress) {
                fileObj.progress = Math.round((100 * evt.loaded) / evt.total);
                this.changeDetectorRef.detectChanges();
            } else if (evt.type === HttpEventType.Response) {
                fileObj.progress = 100;
                const savedfilename = evt.body.dbPath;
                fileObj.serverFile = savedfilename;

                const objFile = new FileAttachmentClass();
                objFile.FileId = 0;
                objFile.FileNameSelected = file.name;
                objFile.FileNameServer = savedfilename;
                objFile.Folder = 'UploadFiles/DocManager/temp/';
                objFile.PageName = 'Tsk5010';
                objFile.TableName = 'Tsk5011';
                objFile.AutoId = 0;

                if (!this.objDa9000Class.AttachmentList) {
                    this.objDa9000Class.AttachmentList = [];
                }
                this.objDa9000Class.AttachmentList.push(objFile);
                this.changeDetectorRef.detectChanges();
            }
        });
    });
}

removePostFile(index: number) {
    const removedFile = this.attachedPostFiles[index];
    this.attachedPostFiles.splice(index, 1);
    if (this.objDa9000Class && this.objDa9000Class.AttachmentList) {
        this.objDa9000Class.AttachmentList = this.objDa9000Class.AttachmentList.filter(
            x => x.FileNameServer !== removedFile.serverFile
        );
    }
}

downloadPostFile(index: number) {
    const file = this.attachedPostFiles[index];
    if (!file) return;
   const fileName = (file.file && file.file.name) ? file.file.name : (file.serverFile || 'download');
    if (file.serverFile) {
        const url = this.currentUrl + 'UploadFiles/DocManager/temp/' + file.serverFile;
        this.forceBlobDownload(url, fileName);
    } else if (file.file instanceof File) {
        const objectUrl = URL.createObjectURL(file.file);
        this.triggerDownload(objectUrl, fileName);
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    }
}

// View-only download for FileAttachments (Section 1 - task attachments from tsk5010)
downloadViewFile(file: any) {
    if (!file) return;
    const fileName = file.FileNameSelected || file.FileNameServer || 'download';
    const folder = file.Folder || 'UploadFiles/DocManager/';
    const url = this.currentUrl + folder + file.FileNameServer;
    this.forceBlobDownload(url, fileName);
}

// View-only download for post attachments (Section 3 - attachmentMap)
downloadPostAttachment(file: any) {
    if (!file) return;
    const fileName = file.FileNameSelected || file.FileNameServer || 'download';
    const folder = file.Folder || 'UploadFiles/DocManager/';
    const url = this.currentUrl + folder + file.FileNameServer;
    this.forceBlobDownload(url, fileName);
}

private forceBlobDownload(url: string, fileName: string) {
    fetch(url)
        .then(response => response.blob())
        .then(blob => {
            const objectUrl = URL.createObjectURL(blob);
            this.triggerDownload(objectUrl, fileName);
            setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
        })
        .catch(err => {
            console.error('Download failed:', err);
            window.open(url, '_blank');
        });
}

private triggerDownload(objectUrl: string, fileName: string) {
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

formatSize(bytes: number): string {
    if (!bytes) return '';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / 1048576).toFixed(1) + ' MB';
}


// previewFile(folder: string, serverFile: string, selectedName: string) {
// 	debugger
//     if (!serverFile) return;

//     const ext = serverFile.split('.').pop().toLowerCase();
//     const url = this.currentUrl + folder + serverFile;
//     const isImage = ['jpg', 'jpeg', 'png', 'gif', 'tif', 'bmp', 'webp'].indexOf(ext) !== -1;
//     const isPdf = ext === 'pdf';

//     if (isPdf) {
//         window.open(url, '_blank');
//         return;
//     }

//     if (isImage) {
//         this.previewUrl = url;
//         this.previewFileName = selectedName || serverFile;
//         this.isImagePreview = true;
//         this.showPreviewModal = true;
//         this.changeDetectorRef.detectChanges();
//         return;
//     }

//     // Other file types - not previewable
//     this.previewUrl = '';
//     this.previewFileName = selectedName || serverFile;
//     this.isImagePreview = false;
//     this.showPreviewModal = true;
//     this.changeDetectorRef.detectChanges();
// }

// previewPostFile(index: number) {

// 	debugger;
//     const file = this.attachedPostFiles[index];
//     if (!file) return;

//     const fileName = (file.file && file.file.name) ? file.file.name : (file.serverFile || '');
//     const ext = fileName.split('.').pop().toLowerCase();
//     const isImage = ['jpg', 'jpeg', 'png', 'gif', 'tif', 'bmp', 'webp'].indexOf(ext) !== -1;
//     const isPdf = ext === 'pdf';

//     if (file.file instanceof File) {
//         if (isPdf) {
//             const objectUrl = URL.createObjectURL(file.file);
//             window.open(objectUrl, '_blank');
//             return;
//         }
//         if (isImage) {
//             const objectUrl = URL.createObjectURL(file.file);
//             this.previewUrl = objectUrl;
//             this.previewFileName = fileName;
//             this.isImagePreview = true;
//             this.showPreviewModal = true;
//             this.changeDetectorRef.detectChanges();
//             return;
//         }
//     } else if (file.serverFile) {
//         this.previewFile('UploadFiles/DocManager/temp/', file.serverFile, fileName);
//         return;
//     }

//     // Not previewable
//     this.previewUrl = '';
//     this.previewFileName = fileName;
//     this.isImagePreview = false;
//     this.showPreviewModal = true;
//     this.changeDetectorRef.detectChanges();
// }

// closePreview() {
//     this.showPreviewModal = false;
//     this.previewUrl = '';
//     this.previewFileName = '';
//     this.isImagePreview = false;
//     this.changeDetectorRef.detectChanges();
// }


}
